module.exports = __webpack_public_path__ + "static/telegraph-16a179b6af936244562e2dbb01855063.svg";